import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index'
import detail from '@/components/detail'
import shoppingCar from '@/components/common/shoppingCar'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{
        title:'口袋优选'
      }
    },
    {
      path:'/detail',
      name:'detail',
      component: detail
    },
    {
      path: '/shoppingCar',
      name:'shoppingCar',
      component: shoppingCar
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js